/* Contexts */
import useAuth from "../../hooks/useAuth";
/* External Libs */
import jwt_decode from "jwt-decode";
/* Api */
import { createDeceased } from "../../api/pro/deceasedReq";
/* Helpers */
import {
    checkRequiredFields,
    getErrorListFromValidation,
    removeErrorList
} from "../../helper/tools";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useDeceased from "../../hooks/useDeceased";
import useData from "../../hooks/useData";
import Header from "../../components/common/Header";
import FormGeneralInfos from "./FormGeneralInfos";
import FormBirthInfos from "./FormBirthInfos";
import FormDeathInfos from "./FormDeathInfos";
import gestionDefunt from "../../img/v2_i_gestionDefunt.png";
import Icon from "../../components/common/Icon";

export default function FormDeceasedNew() {
    const { auth } = useAuth();
    const token = auth?.token;
    const decodedToken = jwt_decode(token);
    const agencyId = decodedToken?.agency;
    const navigate = useNavigate();
    const { newForm, setNewForm } = useDeceased({});
    const { setSelectedCity } = useData({});

    // Repartir d'un état vierge à chaque arrivée sur la création d'un défunt : `newForm` et
    // `selectedCity` sont des contextes partagés qui, sinon, gardent les données (dont l'adresse)
    // d'une précédente création abandonnée ou d'un autre défunt.
    useEffect(() => {
        setNewForm({});
        setSelectedCity(null);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!checkRequiredFields()) {
            return;
        }
        let body = {
            deceasedId: 0,
            agencyId: agencyId,
            title: newForm?.title,
            civility: newForm?.civility || "M",
            hiddenCivility: newForm?.hiddenCivility || false,
            lastName: newForm?.lastName?.trim(),
            firstName: newForm?.firstName?.trim(),
            birthName: newForm?.birthName?.trim(),
            birthDate: newForm?.birthDate,
            isListed: newForm?.isListed === 1 || newForm?.isListed === "1",
            portrait: newForm?.portrait,
            useGalleryPortrait: newForm?.useGalleryPortrait || false,
            file: newForm?.file || undefined,
            file_name: newForm?.file_name || undefined,
            deathDate: newForm?.deathDate,
            actualplace: {
                address: newForm?.actualplace?.address,
                addressComp: newForm?.actualplace?.addressComp,
                zipcode: newForm?.actualplace?.zipcode,
                city: newForm?.actualplace?.city,
                country: newForm?.actualplace?.country || "FR",
            },
            birthplace: {
                zipcode: newForm?.birthplace?.zipcode,
                city: newForm?.birthplace?.city,
                country: newForm?.birthplace?.country || "FR",
            },
            deathplace: {
                zipcode: newForm?.deathplace?.zipcode,
                city: newForm?.deathplace?.city,
                country: newForm?.deathplace?.country || "FR"
            }
        }

        await createDeceased(token, body)
            .then(response => {
                removeErrorList();
                if (!response?.response?.data?.error) {
                    setNewForm()
                    navigate(`/defunt/${response?.deceasedId}`)
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
    }

    const handlePublicationChange = (e) => {
        const value = parseInt(e.target.value);
        setNewForm({ ...newForm, isListed: value });
    };

    return (
        <main>
            <Header
                parent="Tableau de bord"
                location="Création d'un défunt"
                slug={`/`}
            />
            <div className="content-container">
                <Icon source={gestionDefunt} span="Création d'un défunt"/>
                <form noValidate>
                    <div className="creation-defunt">
                        <FormGeneralInfos legend="Informations générales" />
                        <FormBirthInfos required={true} fullForm={newForm} setFullForm={setNewForm} />
                        <FormDeathInfos legend="Informations de décès" fullForm={newForm} setFullForm={setNewForm} />
                        <div className="publication-internet">
                            <label className="required" htmlFor="isListed">
                                Autoriser la publication de la page du défunt sur Internet ?
                            </label>
                            <div className="publication-options">
                                <div className="publication-option">
                                    <input
                                        type="radio"
                                        id="isListed1"
                                        name="isListed"
                                        value={1}
                                        required
                                        onChange={handlePublicationChange}
                                    />
                                    <label htmlFor="isListed1">Oui</label>
                                </div>
                                <div className="publication-option">
                                    <input
                                        type="radio"
                                        id="isListed0"
                                        name="isListed"
                                        value={0}
                                        onChange={handlePublicationChange}
                                    />
                                    <label htmlFor="isListed0">Non</label>
                                </div>
                            </div>
                        </div>
                        <div className="errors"></div>
                    </div>
                </form>
                <div className="buttons-container deceased-create-actions">
                    <button type="button" onClick={() => navigate(-1)}>
                        <i className="fa fa-arrow-left"></i>
                        <span>Retour</span>
                    </button>
                    <button type="button" className="green-button" onClick={handleSubmit}>
                        <i className="fa fa-check"></i>
                        <span>Créer le dossier</span>
                    </button>
                </div>
            </div>
        </main>
    )
}